app.service('pickupPointsFilter', function() {
	let $self, $filterOptions, $filterOptionTypeAll;
	let activeFilters = [];
	let onChangeCallback;

	function init(callback) {
		onChangeCallback = callback;
		setElements();
		setEvents();
	}

	function setElements() {
		$self = $('#pickup-points-filter');
		let $allOptions = $('.filter-option', $self);
		$filterOptionTypeAll = $allOptions.filter(`[data-type=ALL]`);
		$filterOptions = $allOptions.not($filterOptionTypeAll);
	}

	function setEvents() {
		$filterOptions.click(handleClickOption);
		$filterOptionTypeAll.click(clearSelectedFilters);
	}

	function handleClickOption() {
		const optionType = $(this).data('type');
		if(activeFilters.indexOf(optionType) > -1) {
			$(this).removeClass('is-active');
			activeFilters = activeFilters.filter(f => f !== optionType);
		} else {
			$(this).addClass('is-active');
			activeFilters.push(optionType);
		}

		if(activeFilters.length) {
			$filterOptionTypeAll.removeClass('is-active');
		} else {
			$filterOptionTypeAll.addClass('is-active');
		}

		onChangeCallback(activeFilters);
	}

	function clearSelectedFilters() {
		$filterOptionTypeAll.addClass('is-active');
		$filterOptions.removeClass('is-active');
		activeFilters = [];
		onChangeCallback(activeFilters);
	}

	function getActiveFilters() {
		return activeFilters;
	}

	return {
		init,
		getActiveFilters
	}
});